export default __webpack_public_path__ + "static/media/technologymulti.72f10454.svg";